import { Component } from '@angular/core';

@Component({
    selector: 'app-volunteer',
    imports: [],
    templateUrl: './volunteer.component.html',
    styleUrl: './volunteer.component.scss'
})
export class VolunteerComponent {

}
